import { createValidIcon } from '@ui/icons/utils/type-helper'

export const LeaderBoardIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M15 3C16.1046 3 17 3.89543 17 5V12H20C21.1046 12 22 12.8954 22 14V18L22.1025 18.0049C22.6067 18.0562 23 18.4823 23 19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19C1 18.4823 1.39333 18.0562 1.89746 18.0049L2 18V10C2 8.89543 2.89543 8 4 8H7V5C7 3.89543 7.89543 3 9 3H15ZM4 18H7V10H4V18ZM9 18H15V5H9V18ZM17 18H20V14H17V18ZM12.3281 8.12793C12.5146 8.12795 12.6878 8.16815 12.8477 8.24805C13.0077 8.32805 13.1364 8.45336 13.2324 8.62402C13.3337 8.78933 13.3838 9.00839 13.3838 9.28027V13.1836C13.3838 13.4183 13.3144 13.6164 13.1758 13.7764C13.0371 13.9362 12.8314 14.0156 12.5596 14.0156C12.2986 14.0155 12.0961 13.9361 11.9521 13.7764C11.8081 13.6164 11.7363 13.4183 11.7363 13.1836V10.3203H11.5762C11.5388 10.4429 11.4585 10.5525 11.3359 10.6484C11.2133 10.7443 11.0586 10.792 10.8721 10.792C10.6694 10.792 10.4906 10.7251 10.3359 10.5918C10.1867 10.4531 10.1123 10.2609 10.1123 10.0156C10.1124 9.82912 10.155 9.67186 10.2402 9.54395C10.3256 9.416 10.4351 9.29059 10.5684 9.16797L11.1523 8.64844C11.3549 8.46716 11.5438 8.33587 11.7197 8.25586C11.8957 8.17053 12.0988 8.12793 12.3281 8.12793Z'
        fill={color}
      />
    </svg>
  )
})
